export class MessageEnum{
    public static DATASAVED:string ='Person data saved...'; 
    public static PROJECTDATA = 'Project Data Saved...';
    public static FAIL:string ='fail'; 
    public static SUCCESS:string ='success'; 
   

}